/** Random UUID for new records. Do not put the title in the id. */
export function randomId(): string {
  return crypto.randomUUID();
}

/** @deprecated Prefer randomId(). Kept for tests and any leftover slug ids. */
export function slugId(title: string): string {
  const base = title
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s]/g, '')
    .replace(/\s+/g, '-')
    .slice(0, 40)
    .replace(/-+$/, '');
  const suffix = Math.random().toString(36).slice(2, 6);
  return base ? `${base}-${suffix}` : `item-${Date.now().toString(36)}`;
}

/**
 * Generates a prefixed ID with a timestamp + random suffix.
 * Used for records where the title is not user-controlled (e.g. wheel sections).
 *
 * e.g. "sec-1m8xq2-a3f1"
 */
export function prefixedId(prefix: string): string {
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
}
